import { useEffect, useState } from "react"
import { selectFiltersBasedOnKey } from "../../../../lib/filters";

import classes from './SpecificFilter.module.css'
import MultipleOptions from "./MultipleOptions";

import SingleOptionV2 from "./SingleOptionV2";
import DateRangeOption from "./DateRangeOption";
import GroupedOption from "./GroupedOption";
import RadioOption from "./RadioOption";
import CheckBoxOption from "./CheckBoxOption";
import InputOption from "./InputOption";
import AsyncOption from "./AsyncOption";
import CheckBoxMultiArrayOption from "./CheckBoxMultiArrayOption";
import CurrencyRangeOption from "./CurrencyRangeOption";
import DateOperatorOption from "./DateOperatorOption";

export default function SpecificFilter({item, mainSelectAction, generalAsyncSearchFilter, filtersValues, workQ, nameRepeater, isQuickFilter, showTopLabel}) {       

    const [objStructure, setObjectStructure] = useState(null)
    useEffect(() => {

        let selection = selectFiltersBasedOnKey(item.key)
        setObjectStructure(selection)       

    }, [item])

    // When showTopLabel, render one shared label above and hide child control labels so the grid stays even.
    const controlItem = showTopLabel ? { ...item, label: null } : item

    return <>
        {objStructure && !objStructure.disabled && <>
            <div className={classes.row}>
                {showTopLabel && item.label ? <div className={classes.label}>{item.label}</div> : null}
                {objStructure && objStructure.key != 'payer_type_filters' && <>
                    {objStructure.type == 'select' && 
                        <SingleOptionV2 filtersValues={filtersValues} item={controlItem} options={objStructure.options} mainSelectAction={mainSelectAction} classes={classes} workQ={workQ}/>   
                    }
                    {objStructure.type == 'multiple_select' && 
                        <MultipleOptions filtersValues={filtersValues} item={controlItem} options={objStructure.options} mainSelectAction={mainSelectAction} workQ={workQ} classes={classes} hasRemove={objStructure.hasRemove}/>
                    }
                    {objStructure.type == 'range' && 
                        <DateRangeOption filtersValues={filtersValues} item={showTopLabel ? item : controlItem} mainSelectAction={mainSelectAction} workQ={workQ} classes={classes} hideLabel={!!showTopLabel}/>
                    }
                    {objStructure.type == 'date_operator' && 
                        <DateOperatorOption filtersValues={filtersValues} item={controlItem} mainSelectAction={mainSelectAction} workQ={workQ} classes={classes}/>
                    }
                    {objStructure.type == 'group_select' && 
                        <GroupedOption filtersValues={filtersValues} item={controlItem} options={objStructure.options} mainSelectAction={mainSelectAction} workQ={workQ} classes={classes}/>
                    }
                    {objStructure.type == 'radio' && 
                        <RadioOption filtersValues={filtersValues} item={controlItem} options={objStructure.options} mainSelectAction={mainSelectAction} workQ={workQ} classes={classes}/>
                    }
                    {objStructure.type == 'checkbox' && 
                        <CheckBoxOption filtersValues={filtersValues} item={showTopLabel ? item : controlItem} mainSelectAction={mainSelectAction} workQ={workQ} classes={classes} hideLabel={!!showTopLabel}/>
                    }
                    {objStructure.type == 'text' && 
                        <InputOption filtersValues={filtersValues} item={controlItem} mainSelectAction={mainSelectAction} workQ={workQ} classes={classes}/>
                    }
                    {objStructure.type == 'number' && 
                        <InputOption filtersValues={filtersValues} item={controlItem} mainSelectAction={mainSelectAction} workQ={workQ} classes={classes} isNumber={true}/>
                    }
                    {objStructure.type == 'currency_range' && 
                        <CurrencyRangeOption filtersValues={filtersValues} item={controlItem} mainSelectAction={mainSelectAction} workQ={workQ} classes={classes} isQuickFilter={isQuickFilter}/>
                    }
                    {objStructure.type == 'group_select_multiple' && 
                        <GroupedOption filtersValues={filtersValues} item={controlItem} options={objStructure.options} mainSelectAction={mainSelectAction} workQ={workQ} classes={classes} isMultiple={true}/>
                    }
                    {objStructure.type == 'checkbox_multi_array' && 
                        <CheckBoxMultiArrayOption filtersValues={filtersValues} item={controlItem} options={objStructure.options} mainSelectAction={mainSelectAction} workQ={workQ} classes={classes}/>
                    }

                    {objStructure.type == 'select_async' && 
                        <AsyncOption classes={classes} filtersValues={filtersValues} item={controlItem} action={generalAsyncSearchFilter} path={objStructure.path} itemObj={objStructure}/>
                    }
                </>}
            </div>
        </>}

    </>
}
